import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzPupBl } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_PUP_BL: Record<
  Exclude<PageIdWoofzPupBl, PageIdWoofzPupBl.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageIdWoofzPupBl.DOG_AGE_PUP_BL]: {
    id: PageIdWoofzPupBl.DOG_AGE_PUP_BL,
    hasHeader: true,
  },
  [PageIdWoofzPupBl.DOG_OWNER_PUP_BL]: {
    id: PageIdWoofzPupBl.DOG_OWNER_PUP_BL,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPupBl.TRAINING_COMMANDS_PUP_BL]: {
    id: PageIdWoofzPupBl.TRAINING_COMMANDS_PUP_BL,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPupBl.URGE_PAGE_PUP_BL]: {
    id: PageIdWoofzPupBl.URGE_PAGE_PUP_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.URGE,
  },
  [PageIdWoofzPupBl.DOG_BREED_PUP_BL]: {
    id: PageIdWoofzPupBl.DOG_BREED_PUP_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupBl.FACING_CHALLENGES_PUP_BL]: {
    id: PageId.FACING_CHALLENGES_PUP_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupBl.FACING_CHALLENGES_2_PUP_BL]: {
    id: PageIdWoofzPupBl.FACING_CHALLENGES_2_PUP_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupBl.BEHAVIOR_FREQUENCY_PUP_BL]: {
    id: PageIdWoofzPupBl.BEHAVIOR_FREQUENCY_PUP_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupBl.URGE_PROGRAM_PUP_BL]: {
    id: PageIdWoofzPupBl.URGE_PROGRAM_PUP_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPupBl.BEHAVIOR_FEELINGS_PUP_BL]: {
    id: PageIdWoofzPupBl.BEHAVIOR_FEELINGS_PUP_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupBl.FIX_BEHAVIOR_PUP_BL]: {
    id: PageIdWoofzPupBl.FIX_BEHAVIOR_PUP_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupBl.URGE_PAGE_4_PUP_BL]: {
    id: PageIdWoofzPupBl.URGE_PAGE_4_PUP_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPupBl.COMMANDS_PUP_BL]: {
    id: PageIdWoofzPupBl.COMMANDS_PUP_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupBl.PARENT_GOAL_PUP_BL]: {
    id: PageIdWoofzPupBl.PARENT_GOAL_PUP_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupBl.TRAINING_PLACE_PUP_BL]: {
    id: PageIdWoofzPupBl.TRAINING_PLACE_PUP_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupBl.TRAINING_FREQUENCY_PUP_BL]: {
    id: PageIdWoofzPupBl.TRAINING_FREQUENCY_PUP_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupBl.URGE_PAGE_5_PUP_BL]: {
    id: PageIdWoofzPupBl.URGE_PAGE_5_PUP_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.URGE,
  },
  [PageIdWoofzPupBl.PREPARE_FLOW_PUP_BL]: {
    id: PageIdWoofzPupBl.PREPARE_FLOW_PUP_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPupBl.EMAIL_PUP_BL]: {
    id: PageIdWoofzPupBl.EMAIL_PUP_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPupBl.NEWSLETTER_URGE_PUP_BL]: {
    id: PageIdWoofzPupBl.NEWSLETTER_URGE_PUP_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPupBl.LAST_CHANCE_OFFER_PUP_BL]: {
    id: PageIdWoofzPupBl.LAST_CHANCE_OFFER_PUP_BL,
  },
  [PageIdWoofzPupBl.SUBSCRIPTIONS_PUP_BL]: {
    id: PageIdWoofzPupBl.SUBSCRIPTIONS_PUP_BL,
  },
  [PageIdWoofzPupBl.CHAT_UPSELL_PUP_BL]: {
    id: PageIdWoofzPupBl.CHAT_UPSELL_PUP_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzPupBl.UPSELL_PUP_BL]: {
    id: PageIdWoofzPupBl.UPSELL_PUP_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzPupBl.UPSELL_FEEDING_GUIDE_PUP_BL]: {
    id: PageIdWoofzPupBl.UPSELL_FEEDING_GUIDE_PUP_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzPupBl.UPSELL_EMOTIONAL_SUPPORT_PUP_BL]: {
    id: PageIdWoofzPupBl.UPSELL_EMOTIONAL_SUPPORT_PUP_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzPupBl.DOWNLOAD_PUP_BL]: {
    id: PageIdWoofzPupBl.DOWNLOAD_PUP_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
